// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import "aos/dist/aos.css";
import AOS from "aos";

import "glightbox/dist/css/glightbox.min.css";
import GLightbox from "glightbox";

AOS.init({
  duration: 800,
  once: true,
  offset: 80,
});

GLightbox({
  selector: ".glightbox",
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);